<template>
  <div class="pay-method">
    <Resource class="goods-image" :src="goodImage"></Resource>
    <PayPrice :text="priceText" class="mt-[20px]" />
    <a-button
      :disabled="!agreementChecked || loading"
      class="hpp-button mt-[12px]"
      type="primary"
      @click="handlePayClick"
    >
      {{ $t('qu-zhi-fu') }}
    </a-button>
    <PayAgreement
      :checked="agreementChecked"
      :buyType="buyType"
      class="mt-[45px] w-[280px]"
      @checked="onChecked"
    />
  </div>
</template>

<script setup lang="ts">
import PayPrice from './pay-price.vue';
import PayAgreement from './pay-agreement.vue';

import type { IOrder } from '~/api/interface/order';
import { BUY_TYPE } from '~/api/interface';

const goodImage = getFeUrl('/youyan-platform/png/home/package.png');

const props = defineProps<{
  agreementChecked: boolean;
  loading: boolean;
  priceText: number;
  order?: IOrder;
  buyType: BUY_TYPE;
}>();

const handlePayClick = () => {
  if (!props.order) {
    return;
  }

  location.href = props.order?.vendor_redirect_url;
};

const emits = defineEmits(['update:agreementChecked']);

function onChecked(checked: boolean) {
  emits('update:agreementChecked', checked);
}
</script>

<style lang="scss" scoped>
.hpp-button {
  width: 280px;
  height: 44px;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
}
.goods-image {
  width: 100%;
  width: 280px;
  height: 197px;
}
</style>
